// =========================
// Overlay open/close
// =========================
function openOverlay({
  title = "Popup",
  bodyHtml = "",
  footerHtml = "",
  anchorEl = null,
  anchorPoint = null,
}) {
  // Close existing overlay if any
  if (activeOverlay) closeOverlay();

  lastFocusedEl = document.activeElement;

  const overlay = document.createElement("div");
  overlay.className = "gform-overlay";
  overlay.innerHTML = `
      <div class="gform-overlay__panel" role="dialog" aria-modal="true" aria-label="${escapeHtml(title)}">
        <div class="gform-overlay__header">
          <strong>${escapeHtml(title)}</strong>
          <button class="gform-overlay__close" type="button" aria-label="Sluiten">×</button>
        </div>
        <div class="gform-overlay__body">
          ${bodyHtml}
        </div>
        ${footerHtml ? `<div class="gform-overlay__footer">${footerHtml}</div>` : ``}
      </div>
    `;

  document.body.appendChild(overlay);
  document.body.style.overflow = "hidden";
  activeOverlay = overlay;

  const panel = overlay.querySelector(".gform-overlay__panel");
  const closeBtn = overlay.querySelector(".gform-overlay__close");

  const doPosition = () => positionPanel(panel, anchorEl, anchorPoint);
  requestAnimationFrame(doPosition);
  setTimeout(doPosition, 0); // extra zekerheid bij late font/layout shifts

  // Re-position bij scroll/resize
  const onScrollOrResize = () => positionPanel(panel, anchorEl, anchorPoint);

  function onKeyDown(e) {
    if (e.key === "Escape") closeOverlay();
  }

  function onOverlayClick(e) {
    if (e.target === overlay) closeOverlay();
  }

  closeBtn.addEventListener("click", closeOverlay);
  overlay.addEventListener("click", onOverlayClick);
  document.addEventListener("keydown", onKeyDown);
  window.addEventListener("resize", onScrollOrResize, { passive: true });

  // Let op: scroll kan op window óf op een scroll-container zitten.
  // We luisteren op capture zodat we ‘m ook pakken als een wrapper scrolt.
  window.addEventListener("scroll", onScrollOrResize, {
    passive: true,
    capture: true,
  });

  // Focus netjes
  closeBtn.focus({ preventScroll: true });

  // Bewaar cleanup
  overlay._cleanup = () => {
    document.removeEventListener("keydown", onKeyDown);
    overlay.removeEventListener("click", onOverlayClick);
    window.removeEventListener("resize", onScrollOrResize, { capture: false });
    window.removeEventListener("scroll", onScrollOrResize, { capture: true });
  };

  return overlay;
}

function closeOverlay() {
  if (!activeOverlay) return;

  document.body.style.overflow = "";
  if (activeOverlay._cleanup) activeOverlay._cleanup();
  activeOverlay.remove();
  activeOverlay = null;

  // Focus terug
  if (lastFocusedEl && typeof lastFocusedEl.focus === "function") {
    lastFocusedEl.focus({ preventScroll: true });
  }
}

let activeOverlay = null;
let lastFocusedEl = null;

function escapeHtml(str) {
  return String(str ?? "")
    .replaceAll("&", "&amp;")
    .replaceAll("<", "&lt;")
    .replaceAll(">", "&gt;")
    .replaceAll('"', "&quot;")
    .replaceAll("'", "&#039;");
}

// ==========================================
// Positioning: anchor + clamp binnen viewport
// ==========================================
function positionPanel(panel, anchorEl, anchorPoint) {
  const PAD = 12;
  const GAP = 10;

  // Default (fallback): center
  panel.style.position = "fixed";
  panel.style.left = "50%";
  panel.style.top = "50%";
  panel.style.transform = "translate(-50%, -50%)";

  // Bepaal "anker" (rect) uit element óf uit klikpunt
  let anchorRect = null;

  if (anchorEl && typeof anchorEl.getBoundingClientRect === "function") {
    anchorRect = anchorEl.getBoundingClientRect();
  } else if (
    anchorPoint &&
    Number.isFinite(anchorPoint.x) &&
    Number.isFinite(anchorPoint.y)
  ) {
    // Virtuele rect rondom de klik
    anchorRect = {
      left: anchorPoint.x,
      right: anchorPoint.x,
      top: anchorPoint.y,
      bottom: anchorPoint.y,
    };
  } else {
    return; // niks om aan te ankeren
  }

  // Panel meetbaar maken
  panel.style.left = "0px";
  panel.style.top = "0px";
  panel.style.transform = "none";

  const panelRect = panel.getBoundingClientRect();
  const vw = window.innerWidth;
  const vh = window.innerHeight;

  // Voorkeur: onder de anchor, links uitgelijnd
  let top = anchorRect.bottom + GAP;
  let left = anchorRect.left;

  // Flip naar boven als onder niet past
  const spaceBelow = vh - anchorRect.bottom;
  const spaceAbove = anchorRect.top;

  if (spaceBelow < panelRect.height + PAD && spaceAbove > spaceBelow) {
    top = anchorRect.top - panelRect.height - GAP;
  }

  // Als links uitlijnen niet past, probeer rechts uitlijnen
  if (left + panelRect.width + PAD > vw) {
    left = anchorRect.right - panelRect.width;
  }

  // Clamp binnen viewport
  top = Math.max(PAD, Math.min(top, vh - panelRect.height - PAD));
  left = Math.max(PAD, Math.min(left, vw - panelRect.width - PAD));

  panel.style.left = `${left}px`;
  panel.style.top = `${top}px`;
  panel.style.transform = "none";
}

function initElements() {
  // --- Kenteken input (zoals je al had) ---
  document.querySelectorAll(".nl-kenteken input").forEach((field) => {
    field.addEventListener("input", function () {
      let v = field.value.toUpperCase().replace(/[^A-Z0-9]/g, "");
      v = v.slice(0, 6);
      field.value = v;
    });
  });

  // =========================
  // Reviews: Lees volledig
  // =========================
  const ENTRY_HEIGHT = 220;
  const RESERVED_SPACE = 80;

  document.querySelectorAll(".gform-entry").forEach((entry) => {
    const message = entry.querySelector(".message");
    if (!message) {
      return;
    }

    const textHeight = message.scrollHeight;
    const maxTextHeight = ENTRY_HEIGHT - RESERVED_SPACE;

    if (textHeight <= maxTextHeight) {
      return;
    }

    const btn = document.createElement("button");
    btn.type = "button";
    btn.className = "gform-read-full";
    btn.textContent = "Lees volledig";

    const wrapper = document.createElement("div");
    wrapper.classList.add("read-more");
    wrapper.appendChild(btn);

    message.closest(".gform-entry").append(wrapper);

    btn.addEventListener("click", (e) => {
      openOverlay({
        title: "Review",
        bodyHtml: entry.innerHTML,
        anchorEl: e.currentTarget,
        anchorPoint: { x: e.clientX, y: e.clientY },
      });
    });
  });

  // =========================
  // Sidebar link popup
  // =========================
  document.querySelectorAll(".js-sidebar-popup").forEach((link) => {
    link.addEventListener("click", (e) => {
      e.preventDefault();

      const title = link.dataset.title || "Info";
      const text = link.dataset.text || "";
      const ctaLabel = link.dataset.ctaLabel || "Lees meer";
      const ctaHref = link.dataset.ctaHref || link.getAttribute("href") || "#";

      const bodyHtml = `
        <div class="sidebar-popup">
          <p>${escapeHtml(text)}</p>
        </div>
      `;

      const footerHtml = `
        <a class="btn btn-primary sidebar-popup__cta" href="${escapeHtml(ctaHref)}" target="_top">
          ${escapeHtml(ctaLabel)}
        </a>
      `;

      openOverlay({
        title,
        bodyHtml,
        footerHtml,
        anchorEl: e.currentTarget,
        anchorPoint: { x: e.clientX, y: e.clientY },
      });
    });
  });
}

document.addEventListener("DOMContentLoaded", function () {
  initElements();
});

document.addEventListener("click", function (evt) {
  const { target } = evt;
  if (!target) {
    return;
  }

  const link = target.closest("a[href]");
  if (!link) {
    return;
  }

  const currentCapture = link.closest(".js-capture-links");
  if (!currentCapture) {
    return;
  }

  const href = link.getAttribute("href") || "";
  const isHash = href.startsWith("#");
  const isJs = href.toLowerCase().startsWith("javascript:");
  const isMail = href.toLowerCase().startsWith("mailto:");
  const isTel = href.toLowerCase().startsWith("tel:");

  if (
    link.target === "_blank" ||
    link.hasAttribute("download") ||
    isHash ||
    isJs ||
    isMail ||
    isTel
  ) {
    return;
  }

  evt.preventDefault();
  currentCapture.classList.add("loading");

  try {
    fetch(link.href, {
      method: "GET",
      credentials: "same-origin",
      headers: { "X-Requested-With": "XMLHttpRequest" },
    }).then((response) => {
      if (!response.ok) {
        throw new Error(`HTTP ${response.status}`);
      }

      response.text().then((html) => {
        const doc = new DOMParser().parseFromString(html, "text/html");
        const nextCapture = doc.querySelector(".js-capture-links");

        if (!nextCapture) {
          throw new Error("Missing .js-capture-links in fetched page");
        }

        nextCapture.classList.add("loading");
        currentCapture.replaceWith(nextCapture);
        window.history.pushState({}, "", link.href);

        setTimeout(() => {
          nextCapture.classList.remove("loading");
          nextCapture.scrollIntoView({ behavior: "smooth" });
          initElements();
        }, 100);
      });
    });
  } catch (err) {
    window.location.assign(link.href);
  }
  return false;
});

document.addEventListener("click", (evt) => {
  const { target } = evt;
  if (!target) {
    return;
  }
  const button = target.closest(".js-review-models-button");
  if (!button) {
    const activeButton = document.querySelector(
      ".js-review-models-button.active",
    );
    if (activeButton) {
      activeButton.classList.remove("active");
    }
    return;
  }

  button.classList.toggle("active");
});
